export const helpUrls = {
  customerSupport: 'https://t.me/ProjectSerum',
  customerSupportZh: 'https://t.me/ProjectSerum_Chinese',
  contactEmail: 'mailto:contact@projectserum.com',
  discord: 'https://discord.gg/EDvudv6',
  telegram: 'https://t.me/ProjectSerum',
  github: 'https://github.com/project-serum',
  projectSerum: 'https://projectserum.com/',
  developerResources: 'https://projectserum.com/developer-resources',
  solanaBeach: 'https://solanabeach.io',
  mission6: 'https://mission6.io',
};
